module.exports = __webpack_public_path__ + "static/media/sm_youtube.68a81ce9.svg";